<template>
    <div>
        <p class="label" :class="{'text--disabled': disabled}">{{ label }}</p>
        <MultiplePickerInput
                :value="value"
                @input="onInput"
                :items="items"
                :loading="loading"
                :disabled-check-all="true"
                v-bind="$attrs"
                :disabled="disabled"
        />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import ObtainedSpecialityService from '@/services/obtained-speciality.service.js';

  export default {
    name: "ObtainedMajorMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Nom du Diplôme'},
      diplomaIds: {type: Array, default: () => []},
      listOriginal: Array,
      obtainedMajorIds: Array,
    },
    data() {
      return {
        // items: [],
        loading: false,
        timeoutHandler: null,
      }
    },
    computed: {
      items() {
        if (!this.listOriginal.length) return [];

        const items = [];
        this.listOriginal.forEach((item) => {
          if (!item.id) return;

            items.push({
              id: item.id,
              name: item.name
            });
        });

        return items;
      },
      disabled() {
        return this.items && !this.items.length;
      }
    },
    methods: {
      loadListItem(diplomaIds) {
        const _this = this;

        this.loading = true;

        ObtainedSpecialityService.getList(diplomaIds)
          .then(({data}) => {
            if (_this.diplomaIds.length) {
              _this.$emit('update:list-original', data);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      diplomaIds: {
        immediate: true,
        handler(value) {
          const _this = this;

          // Reset data
          this.$emit('input', []);
          this.$emit('update:list-original', []);

          if (Array.isArray(value) && value.length > 0) {
            clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              _this.loadListItem(value);
            }, 1000);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
